<template>
  <svg class="block" xmlns="http://www.w3.org/2000/svg" :width="width" :height="width" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <polyline v-if="active" points="9 11 12 14 22 4"></polyline>
    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
  </svg>
</template>

<script>
export default {
  name: 'CheckIcon',
  props: {
    active: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 24
    }
  }
}
</script>
